import ComponentModule from "@eisinc/Overrides/Components/ScheduleReminderModal";

export * from "@eisinc/Overrides/Components/ScheduleReminderModal";

export default ComponentModule;
